import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FindControlIdService, WebCommonStorageRepository } from 'webcommon/legacy-common';
import {
  FindControlRequiredSearchParametersDto,
  IColumnPk,
  MacroAddProcedureDto,
  MacroDataSourceEnum,
  MacroDefinitionDto,
  MacroGroupDto,
} from 'webcommon/shared';
import { MacroService } from '../ap-macro/index';

@Component({
  selector: 'ap-macro-editor-details',
  templateUrl: './ap-macro-editor-details.component.html',
})

export class ApMacroEditorDetailsComponent implements OnInit {
  @Input() baseId: string;
  @Input() macroService: MacroService;
  @Input() macroDefinitionDto: MacroDefinitionDto;
  @Input() defaultMacroGroup: MacroGroupDto | null;
  @ViewChild('form', { static: true }) ngForm: NgForm;
  @ViewChild('goalTextArea', { static: true }) goalTextArea: ElementRef;

  allowDxMultiSelect = true;
  contextId: string;
  dataSource: MacroDataSourceEnum;
  description: string;
  findControlSearchParams: FindControlRequiredSearchParametersDto =
    {
      RequiredSearchParameters:
        [
          {
            ColumnName: 'UserUid',
            Value: this.getDefaultUserId(),
          },
        ],
    };
  Id: string;
  goal: string;
  groups: string[] = [];
  contents: string[];
  disableVisitFields = false;

  macroDiagnosis: IColumnPk[];
  socodes: string[] = [];
  spcodes: string[] = [];

  goalError: string | null = null;
  goalEnabled = true;
  groupError: string | null = null;

  constructor(
    public findControlIdService: FindControlIdService,
    private webCommonStorageRepository: WebCommonStorageRepository) {
  }

  ngOnInit() {
    this.setId();
    if (this.macroDefinitionDto.AddSOs && this.macroDefinitionDto.AddSOs.length > 0) {
      this.macroDefinitionDto.AddSOs.forEach((procedure) => this.socodes.push(procedure.ProcedureId));
    }

    if (this.macroDefinitionDto.AddSPs && this.macroDefinitionDto.AddSPs.length > 0) {
      this.macroDefinitionDto.AddSPs.forEach((procedure) => this.spcodes.push(procedure.ProcedureId));
    }

    if (this.macroDefinitionDto && this.macroDefinitionDto.AddDxs) {
      this.macroDiagnosis = this.macroDefinitionDto.AddDxs.map((dx) => {
        return { Pk: dx.Id, Code10: dx.Code10, CodeDescription: dx.CodeDescription, LexicalCode: dx.LexicalCode };
      });
    } else {
      this.macroDiagnosis = [];
    }
    if (this.macroDefinitionDto && this.macroDefinitionDto.MacroGroup && this.macroDefinitionDto.MacroGroup.MacroGroupId) {
      this.groups = [this.macroDefinitionDto.MacroGroup.MacroGroupId];

    } else {
      this.groups = [];
      if (this.defaultMacroGroup) {
        this.macroDefinitionDto.MacroGroup = this.defaultMacroGroup;
        this.groups = [this.defaultMacroGroup.MacroGroupId];
      }
    }
    this.validateGoalCriteria();
    const visitId = this.macroService.getVisitId();
    if (!visitId || visitId === '') {
      this.disableVisitFields = true;
      this.goalEnabled = false;
    }
  }

  onMacroGroupSelected(macroGroups: string[]) {
    if (macroGroups && macroGroups.length > 0) {
      this.macroDefinitionDto.MacroGroup = { MacroGroupId: macroGroups[0], Name: '' };
      this.groups = [macroGroups[0]];
      this.groupError = null;
    } else {
      this.macroDefinitionDto.MacroGroup = { MacroGroupId: '', Name: '' };
      this.groups = [];
    }
  }

  isFormValid() {
    return this.ngForm.valid;
  }

  hasGroupError(): boolean {
    return this.groupError != null;
  }

  hasGoalError(): boolean {
    return this.goalError != null;
  }

  isInputValid() {
    this.validateGoalCriteria();
    return !this.hasGroupError() && !this.hasGoalError();
  }

  onSOSelected(procedureIds: string[]) {
    this.macroDefinitionDto.AddSOs = [];
    procedureIds.forEach((id) => this.addSOProcedure(id));
  }

  addSOProcedure(procedureIds: string) {
    const dto = new MacroAddProcedureDto();
    dto.ProcedureId = procedureIds;
    this.macroDefinitionDto.AddSOs.push(dto);
  }

  onSPSelected(procedureIds: string[]) {
    this.macroDefinitionDto.AddSPs = [];
    procedureIds.forEach((id) => this.addSPProcedure(id));
  }

  addSPProcedure(procedureIds: string) {
    const dto = new MacroAddProcedureDto();
    dto.ProcedureId = procedureIds;
    this.macroDefinitionDto.AddSPs.push(dto);
  }

  onDXChipsChanged(value: IColumnPk[]) {
    this.macroDefinitionDto.AddDxs = value.map((dx) => {
      return {
        Code10: dx.Code10,
        CodeDescription: dx.CodeDescription,
        Id: dx.Pk,
        LexicalCode: dx.LexicalCode,
      };
    });
    this.validateGoalCriteria();
  }

  private setId() {
    this.Id = `${this.baseId}-details`;
  }

  private getDefaultUserId() {
    let userId = this.webCommonStorageRepository.getUserId();

    if (!userId) {
      userId = '';
    }

    return userId;
  }

  private validateGoalCriteria(): void {
    this.goalError = null;
    // if (this.macroDefinitionDto.AddDxs.length === 1 || this.macroDefinitionDto.Goal) {
    //   this.goalEnabled = true;
    // }
    // if (this.macroDefinitionDto.AddDxs.length !== 1 && !this.macroDefinitionDto.Goal) {
    //   this.goalEnabled = false;
    // }
    if (this.macroDefinitionDto.AddDxs.length === 0 && this.macroDefinitionDto.Goal) {
      this.goalError = 'A DX Code is required when adding a Goal.';
    }
    if (this.macroDefinitionDto.AddDxs.length > 1 && this.macroDefinitionDto.Goal) {
      this.goalError = 'Only one DX Code is allowed when adding a Goal.';
    }
    if (this.goalError) {
      this.goalTextArea.nativeElement.focus();
    }
  }

}
